/* globals ListadosIndexDTO, ModuloLiderDTO, ListGalleryDTO, __tcfapi */

require("../Alerta/Alerta");
require("../../Global/show-message");
require('slick');
require('../../Global/userprofile-question');
var ListGallery = require('list-gallery');
var valorarApp = require("../../Global/app-rating");
var buscador = require("../Buscador/buscador");
var descartar = require("../DescartarInmueble/DescartarInmueble");
var favoritos = require('../../Common/Favoritos/Favoritos');
var WindowModal = require('../../Global/window-modal');
var HabEvents = require("../../Global/habitaclia-events");
var HabUtils = require("../../Global/habitaclia-utils");
var notificacionesLive = require('../NotificacionesLive/NotificacionesLiveIndex');
var cookieService = require('../../Global/cookie-service');
var jquery = require('jquery');
var Functions = require('../../Desktop/modules/functions');
var DynamicAds = require('../../Common/Ads/dynamic-ads').default;
var ModuloLider = require('../../Common/modulo-lider').default;

require("jquery.dragend");


(function () {
    "use strict";

    var ListadosIndex = function (data) {
        this.__ListadosIndexDTO = ListadosIndexDTO;
        this.__data = data;
        this.__$header = jquery("#header");
        this.__$guestResponseOk = jquery('#js-guest-response-ok');
        this.__$guestBody = jquery('#js-guest-body');
        this.__$leyOmnibusButton = jquery('.ley-omnibus-info-btn');
        this.__$leyOmnibusCloseButton = jquery('.ley-omnibus-close-btn');
        this.__$leyOmnibusContent = jquery('.ley-omnibus-info-content');
        __registerEvents.call(this, data);
        this.dynamicAds = new DynamicAds(ListadosIndexDTO);
        this.__scrolled = false;
        this.__lastScrollTop = 0;
        this.__$header = jquery("#header");
        this.__$header.addClass('header-absolute');
        this.__$homelogo = jquery("#header.home-logo");
        this.__IsSwipeDeviceSupported = data.IsSwipeDeviceSupported;
        this.__$topListados = jquery('.top-listados');
        this.__$ordenar = jquery('.ordenar');
        this.__$minifichashow = jquery('.mini-ficha');
        this.__$isFiltered = (jquery('.filtro-activo').length) ? true : false;
        this.__isScrolling = true;
        this.hasNoMoreCookie = false;
        this.__krCookieName = 'kr_asked';
        this.__krCookieTime = 5256000;
        if (cookieService.hasCookie('nomorelive')) {
            this.hasNoMoreCookie = true;
        }
        if (window.location.href.indexOf("addFav=1") > 0) {
            var codigoAnuncio, realEstateAdId;

            if (window.location.href.indexOf("codigo=") > 0) {
                codigoAnuncio = HabUtils.GetURLParameterFromGivenURL('codigo', window.location.href);
                realEstateAdId = document.getElementById('id'+codigoAnuncio).getAttribute('data-realestateadid');
            }
            favoritos.ManageFavs(undefined, undefined, undefined, codigoAnuncio, realEstateAdId);
        }
        if (!this.hasNoMoreCookie) {
            __initCallAjaxLiveInfo.call(this);
        }
        __callInstallApp.call(this);

        this._listGallery = new ListGallery(ListGalleryDTO);
        __initAsyncAds.call(this);
        /* jshint unused: false */
        var moduloLider = new ModuloLider(ModuloLiderDTO);
        jquery.publish(HabEvents.EventsEnum.ModuloLiderNoCargado);
        __tcfapi && __tcfapi('getTCData',2, (data)=> {
            if (data && data.purpose && data.purpose.consents && data.purpose.consents[6]){
                const oneYear = new Date();
                oneYear.setYear(oneYear.getFullYear()+1);
                cookieService.SetValue('urlUltimoListado', btoa(document.location.pathname), oneYear, '/', this.__ListadosIndexDTO.DomainCookie);
            } else {
                cookieService.removeCookie('urlUltimoListado');
            }
        });
    };

    var __callInstallApp = function () {
        var self = this;
        var isMobileApp = this.__ListadosIndexDTO.IsMobileApp === 'True';
        var target = this.__ListadosIndexDTO.MobileType;
        if (__isValidAppTargetForInstall(isMobileApp, target) && __isRedirectFromAgregador()) {
            var cookieInstallApp = cookieService.hasCookie('cookieInstallApp');
            if (!cookieInstallApp) {
                cookieService.setCookie('cookieInstallApp', 'True', Infinity, '/', this.__ListadosIndexDTO.DomainCookie);
                jquery('.mini-ficha').click(function () {
                    __openMarket.call(self);
                });
            }
        }
    };

    var __openMarket = function () {
        if (this.__ListadosIndexDTO.MobileType.toLowerCase() === 'ios') {
            window.location.href = this.__ListadosIndexDTO.LinkAppMarketIos;
        } else {
            window.location.href = this.__ListadosIndexDTO.LinkAppMarketAndroid;
        }
    };

    var __isValidAppTargetForInstall = function (isMobileApp, target) {
        if (!isMobileApp) {
            if (typeof (target) === 'string') {
                target = target.toLowerCase();
                return (target === 'ios' || target === 'android');
            }
        }
        return false;
    };

    var __isRedirectFromAgregador = function () {
        return window.location.href.indexOf("from=agregador") > 0;
    };

    var __registerEvents = function () {
        var self = this;

        jquery('#alerta-guardada-toast .close-toast, #alerta-guardada-toast .js-button-ok').click(function () {
            jquery('#alerta-guardada-toast').addClass('ocultar');
        });

        jquery('#alerta-guardada-toast .js-cancel-userguest-push').click(function (event) {
            event.preventDefault();

            jquery.ajax({
                type: 'POST',
                url: self.__ListadosIndexDTO.alertaAutoDTO.url,
                data: {
                    idAlerta: self.__ListadosIndexDTO.alertaAutoDTO.idAlerta,
                    ca: self.__ListadosIndexDTO.alertaAutoDTO.ca
                },
                dataType: "json",
                success: function () {
                    var alertaPushCancelled = jquery('#alerta-push-userguest-cancelled');
                    jquery('#alerta-guardada-toast').addClass('ocultar');
                    alertaPushCancelled.removeClass('ocultar');
                    setTimeout(function () { alertaPushCancelled.addClass('ocultar'); }, 5000);
                },
                error: function () { }
            });
        });

        jquery('#list-online-appraisal-button').click(function () {
            __trackEvent.call();
        });    

        jquery(".topNlistado li").click(function () {
            jquery.publish(HabEvents.EventsEnum.ClickAnuncioObraNuevaInteresanteLista, ['Navegacion', 'lista', 'interesantes']);
        });

        jquery("#FiltrosViewModel_Filtros_Order_Selector").change(function () {
            var $ordenar = jquery("option:selected", this);
            var nombreOrden = $ordenar.attr("data-nombre_orden");
            var urlOrden = $ordenar.attr('data-url');

            jquery.publish(HabEvents.EventsEnum.CambioOrdenacionLista, ['Navegacion', 'ordenar', nombreOrden]);
            jquery("#FiltrosViewModel_Filtros_Order").val($ordenar.val());

            if (urlOrden) {
                document.location.href = urlOrden;
            }
        });

        jquery("#aFiltros").click(function () {
            jquery.publish(HabEvents.EventsEnum.ClickMasFiltrosLista, ['Navegacion', 'lista', 'masfiltros']);
        });

        jquery(".favlinkbottom").click(function (evnt) {
            evnt.preventDefault();
            evnt.stopPropagation();
            favoritos.ManageFavs(this);
        });

        jquery("#buscar-listados").click(function () {

            var modal = new WindowModal();
            modal.OnReady(__bindEventsModalSearch);
            modal.OnDestroy(__unbindEventsModalSearch);
            modal.CreateWindowModal({
                idSelectorString: "modal-buscador",
                dataTitle: '<div class="titleModal"></div><a href="#" class="closeModal" role="button" tabindex="8" title="Cerrar"></a>',
                dataBody: jquery("#html-buscador").html(),
                dataFooter: ''
            });

            setTimeout(function () { jquery("#wmContent").css("top", "0"); }, 200);
            buscador.RegisterEvents();

        });

        jquery(window).scroll(function (e) {
            e.stopPropagation();
            __callbackScrollLista.call(self, jquery(this));
            __callbackHideAllMenuItemListado.call(self);
        });

        jquery.subscribe(HabEvents.EventsEnum.DoneDescartarAnuncioDesdeLista, function (data, idAnuncio) {
            var idAnuncioJquery = "#" + idAnuncio;
            var $anuncio = jquery(idAnuncioJquery);
            if ($anuncio) {
                $anuncio.addClass('anuncio-descartado-listado');
            }
        });

        jquery.subscribe(HabEvents.EventsEnum.DoneRecuperarAnuncioDesdeLista, function (data, idAnuncio) {
            var idAnuncioJquery = "#" + idAnuncio;
            var $anuncio = jquery(idAnuncioJquery);
            if ($anuncio) {
                $anuncio.removeClass('anuncio-descartado-listado');
            }
        });

        jquery.subscribe(HabEvents.EventsEnum.NewItemAfterDiscard, function (data, newItemId) {
            __bindOneItem.call(self, newItemId);
        });

        jquery('#js-anchor-busquedas-top').click(function (e) {
            Functions.ScrollTo(jquery(e.currentTarget).attr('data-href'), 0, 500);
        });

        var $itemsListado = jquery('.lista-resultados > ul > li');
        for (var numli = 0; numli < $itemsListado.length; numli++) {
            console.log($itemsListado);
            var idCurrentLi = jquery($itemsListado[numli]).attr('id');
            __bindOneItem.call(self, idCurrentLi);
        }
        valorarApp.RegisterEvents();

        this.__$leyOmnibusButton.on('click', () => {
            this.__$leyOmnibusContent.addClass('show');
        });

        this.__$leyOmnibusCloseButton.on('click', () => {
            this.__$leyOmnibusContent.removeClass('show');
        });
    };

    var __trackEvent = function () {
        jquery.publish(HabEvents.EventsEnum.PropertyValuationLandingButtonClicked, 'list');
    };

    var __initCallAjaxLiveInfo = function () {
        notificacionesLive.InitCallAjaxLiveInfo();
    };

    var __callbackScrollLista = function ($window) {

        var scrollTop = $window.scrollTop();
        var minScroll = 20;
        var breakPoint = 87;

        if (1 < $window.scrollTop() && !this.__scrolled) {
            this.__$homelogo.css("background-color", "transparent");
            this.__scrolled = true;
        }
        if (100 > $window.scrollTop() && this.__scrolled) {
            this.__$header.css("background-color", "rgba(255,102,0)");
            this.__$homelogo.css("background-color", "transparent");
            this.__scrolled = false;
        }

        if (scrollTop < this.__lastScrollTop && scrollTop <= breakPoint) {
            //up
            if (this.__$header.hasClass('header-fixed')) {
                this.__$header.removeClass('header-fixed');
                this.__$header.removeClass('header-fixed-down');
                this.__$topListados.removeClass('top-listados-fixed-down');
                this.__$topListados.removeClass('top-listados-fixed');
                if (this.__$isFiltered) {
                    this.__$ordenar.removeClass('ordenar-margin187');
                    this.__$minifichashow.removeClass('ordenar-margin187');
                } else {
                    this.__$ordenar.removeClass('ordenar-margin141');
                    this.__$minifichashow.removeClass('ordenar-margin141');
                }
            }
        } else if (scrollTop < this.__lastScrollTop && scrollTop > breakPoint && Math.abs(this.__lastScrollTop - scrollTop) >= minScroll) {
            this.__$header.addClass('header-fixed-down');
            this.__$topListados.addClass('top-listados-fixed-down');
        }
        if (scrollTop > this.__lastScrollTop && scrollTop > breakPoint && scrollTop < 200) {
            this.__$header.removeClass('header-fixed-down');
            this.__$header.addClass('header-fixed');
            this.__$topListados.addClass('top-listados-fixed');
            this.__$topListados.removeClass('top-listados-fixed-down');
            if (this.__$isFiltered) {
                this.__$ordenar.addClass('ordenar-margin187');
                this.__$minifichashow.addClass('ordenar-margin187');
            } else {
                this.__$ordenar.addClass('ordenar-margin141');
                this.__$minifichashow.addClass('ordenar-margin141');
            }
        } else if (scrollTop > this.__lastScrollTop && scrollTop >= 200 && Math.abs(this.__lastScrollTop - scrollTop) >= minScroll) {
            this.__$header.removeClass('header-fixed-down');
            this.__$header.addClass('header-fixed');
            this.__$topListados.addClass('top-listados-fixed');
            this.__$topListados.removeClass('top-listados-fixed-down');
            if (this.__$isFiltered) {
                this.__$ordenar.addClass('ordenar-margin187');
                this.__$minifichashow.addClass('ordenar-margin187');
            } else {
                this.__$ordenar.addClass('ordenar-margin141');
                this.__$minifichashow.addClass('ordenar-margin141');
            }
        }
        this.__lastScrollTop = scrollTop;
    };

    var __callbackShowMenuItemListado = function () {
        var idMenuClicked = "#" + this.id;
        var spanMenuId = jquery(idMenuClicked).children("span").attr('id');
        var ulMenuId = jquery(idMenuClicked).children("ul").attr('id');
        var spanMenuIdJQ = '#' + spanMenuId;
        var ulMenuIdJQ = '#' + ulMenuId;
        if (jquery(spanMenuIdJQ).hasClass('active')) {
            jquery(spanMenuIdJQ).removeClass('active');
            jquery(ulMenuIdJQ).addClass('ocultar');
            jquery(ulMenuIdJQ).removeClass('mostrar');
        } else {
            jquery(spanMenuIdJQ).addClass('active');
            jquery(ulMenuIdJQ).removeClass('ocultar');
            jquery(ulMenuIdJQ).addClass('mostrar');
        }
    };

    var __callbackHideMenuItemListado = function (menuId) {
        var idMenuJQ = "#" + menuId;
        var spanMenuId = jquery(idMenuJQ).siblings('.boton-menu').attr('id');
        var spanMenuIdJQ = '#' + spanMenuId;
        jquery(spanMenuIdJQ).removeClass('active');
        jquery(idMenuJQ).removeClass('mostrar');
        jquery(idMenuJQ).addClass('ocultar');
    };

    var __callbackHideAllMenuItemListado = function () {
        jquery('.menu-item-listado .active').removeClass('active');
        jquery('.menu-item-listado .mostrar').addClass('ocultar');
        jquery('.menu-item-listado .mostrar').removeClass('mostrar');
    };

    var __bindEventsModalSearch = function () {
        jquery(".closeModal").on("click", function (e) {
            e.preventDefault();
            jquery.publish(HabEvents.EventsEnum.CloseWindowModal);
        });
    };

    var __unbindEventsModalSearch = function () {
        jquery(".closeModal").off("click");
    };

    var __cambiarTextoFavoritoMenuListado = function (favoritoLiMenu) {
        if (favoritoLiMenu) {
            var favoritoTextSpan = favoritoLiMenu.getElementsByClassName('favoritoTextSpan')[0];
            if (favoritoTextSpan.innerHTML.indexOf('Eliminar') === -1) {
                favoritoTextSpan.innerHTML = 'Eliminar de favoritos';
            }
            else {
                favoritoTextSpan.innerHTML = 'Añadir a favoritos';
            }
        }
    };

    var __bindOneItem = function (idNum) {
        var itemId = '#' + idNum;
        var itemClass = '.f' + idNum;
        jquery(itemClass + ' .favlink').click(function (evnt) {
            evnt.preventDefault();
            evnt.stopPropagation();
            favoritos.ManageFavs(this);
        });

        jquery(itemId).click(function () {
            var esPremium, esOportunidad, esDestacado, esModuloLider, esAdyacencia;
            esPremium = jquery(this).find(".premium").length;
            esOportunidad = jquery(this).find(".oportunidad").length;
            esDestacado = jquery(this).find(".destacado").length;
            esModuloLider = jquery(this).find(".modulolider").length;
            esAdyacencia = jquery(this).find(".adyacencia").length;
            if (esPremium > 0) {
                jquery.publish(HabEvents.EventsEnum.ClickAnuncioPremiumLista, ['Navegacion', 'lista', 'premium']);
            }
            if (esOportunidad > 0) {
                jquery.publish(HabEvents.EventsEnum.ClickAnuncioOportunidadLista, ['Navegacion', 'lista', 'oportunidad']);
            }
            if (esDestacado > 0) {
                jquery.publish(HabEvents.EventsEnum.ClickAnuncioDestacadoLista, ['Navegacion', 'lista', 'destacado']);
            }
            if (esModuloLider > 0) {
                jquery.publish(HabEvents.EventsEnum.ClickAnuncioModuloLiderLista, ['Navegacion', 'lista', 'modulolider']);
            }
            if (esAdyacencia > 0) {
                jquery.publish(HabEvents.EventsEnum.ClickAnuncioAdyacenciasLista, ['Navegacion', 'lista', 'adyacencias']);
            }
        });

        jquery(itemClass + ' .favlink').click(function () {
            if (this.parentElement.parentElement) {
                var favoritoLiMenu = this.parentElement.parentElement.getElementsByClassName('favoritoLI')[0];
                __cambiarTextoFavoritoMenuListado(favoritoLiMenu);
            }
        });

        jquery(itemClass + ' .menu-item-listado').click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            __callbackShowMenuItemListado.call(this);
        });

        jquery(itemClass + ' .favoritoLI').click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            var idFavorito_A_Clickar = this.getAttribute('data-favorito');
            var menuId = this.parentElement.id;
            var favAClickar = document.getElementById(idFavorito_A_Clickar);
            favAClickar && favAClickar.click();
            __callbackHideMenuItemListado.call(this, menuId);
        });

        jquery(itemClass + ' .descartarLI').click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            var dataDescartar = this.getAttribute('data-descartar');
            var idAnuncio = this.getAttribute('data-idanuncio');
            var inmuebleADescartar = __getInmueble_A_Descartar_O_Recuperar_DTO(dataDescartar, idAnuncio);
            var menuId = this.parentElement.id;
            descartar.DescartarInmueble_Con_Parametro(inmuebleADescartar);
            __callbackHideMenuItemListado.call(this, menuId);
            jquery.publish(HabEvents.EventsEnum.ClickDescartarAnuncioDesdeLista);
        });

        jquery(itemClass + ' .descartarDirecto').click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (window.ListadosIndexDTO.UserIsLogged === "False") {
                window.location = window.FavoritosDTO.UrlLogin;
            } else {
                var dataDescartar = this.getAttribute('data-descartar');
                var idAnuncio = this.getAttribute('data-idanuncio');
                var inmuebleADescartar = __getInmueble_A_Descartar_O_Recuperar_DTO(dataDescartar, idAnuncio);
                descartar.DescartarInmueble_Con_Parametro(inmuebleADescartar);
                jquery.publish(HabEvents.EventsEnum.ClickDescartarAnuncioDesdeLista);
            }
        });

        jquery(itemClass + ' .recuperar-anuncio').click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            var dataRecuperar = this.getAttribute('data-recuperar');
            var idAnuncio = this.getAttribute('data-idanuncio');
            var inmuebleARecuperar = __getInmueble_A_Descartar_O_Recuperar_DTO(dataRecuperar, idAnuncio);
            descartar.RecuperarInmueble_Con_Parametro(inmuebleARecuperar);
            jquery.publish(HabEvents.EventsEnum.ClickRecuperarAnuncioDesdeLista);
        });
    };

    var __initAsyncAds = function () {
        setTimeout(() => {
            // jshint ignore:start 
            (function (G, o, O, g, L, e) {
                G[g] = G[g] || function () {
                    (G[g]['q'] = G[g]['q'] || []).push(arguments)
                }, G[g]['t'] = 1 * new Date; L = o.createElement(O), e = o.getElementsByTagName(
                    O)[0]; L.defer = 1; L.src = '//www.google.com/adsense/search/async-ads.js';
                e.parentNode.insertBefore(L, e);
            })(window, document, 'script', '_googCsa');

            var pageOptions = {
                'pubId': 'partner-habitaclia',
                'query': document.title,
                'channel': '5814926489',
                'hl': 'es',
                'linkTarget': '_blank',
                'domainLinkAboveDescription': true,
                'instantPreviews': false,
                'location': false,
                'plusOnes': false,
                'sellerRatings': false,
                'siteLinks': false
            };

            var adblock1 = {
                'container': 'adcontainer1',
                'number': 2,
                'width': '100%',
                'lines': 2,
                'fontSizeTitle': 16,
                'colorTitleLink': '#ff6600',
                'colorText': '#888888',
                'colorDomainLink': '#888888',
                'colorBackground': '#f5f5f5',
                'colorAdBorder': '#f5f5f5',
                'colorBorder': '#f5f5f5',
                'noTitleUnderline': true,
                'detailedAttribution': false
            };
            _googCsa('ads', pageOptions, adblock1);
            // jshint ignore:end 
        }, 5000); 
        
    };

    ListadosIndex.prototype = {
        constructor: ListadosIndex,
    };

    var __getInmueble_A_Descartar_O_Recuperar_DTO = function (dataDescartarInmueble, idAnuncio) {
        var arrayInmuebleInfo = dataDescartarInmueble.split('-');
        var InmuebleDTO = {
            CodInm: arrayInmuebleInfo[0],
            CodEmp: arrayInmuebleInfo[1],
            CodOfi: arrayInmuebleInfo[2],
            IdAnuncio: idAnuncio
        };
        return InmuebleDTO;
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports.ListadosIndex = new ListadosIndex(ListadosIndexDTO);
    }
    else {
        window.ListadosIndex = new ListadosIndex(ListadosIndexDTO);
    }
}());